'use client';

import MetricBarChart from '../MetricBarChart';
import MetricLineChart from '../MetricLineChart';

// Sample data: Sprint velocity over time
const velocityData = [
  { name: 'Sprint 1', points: 28 },
  { name: 'Sprint 2', points: 32 },
  { name: 'Sprint 3', points: 34 },
  { name: 'Sprint 4', points: 31 },
  { name: 'Sprint 5', points: 36 },
  { name: 'Sprint 6', points: 35 },
  { name: 'Sprint 7', points: 38 },
  { name: 'Sprint 8', points: 37 },
];

// Sample data: Team velocity comparison
const teamComparisonData = [
  { name: 'Frontend', thisWeek: 15, lastWeek: 12, average: 14 },
  { name: 'Backend', thisWeek: 8, lastWeek: 10, average: 9 },
  { name: 'Mobile', thisWeek: 6, lastWeek: 5, average: 6 },
  { name: 'DevOps', thisWeek: 4, lastWeek: 6, average: 5 },
];

export function SprintVelocityTrend() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📈 Sprint Velocity Trend</h3>
      <MetricBarChart
        data={velocityData}
        bars={[
          { dataKey: 'points', name: 'Story Points', color: '#E89841' },
        ]}
        xAxisLabel="Sprint"
        yAxisLabel="Story Points Completed"
        targetLine={35}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing stable velocity around 32-38 points per sprint. The team baseline
        is approximately 35 points (green line). Good consistency indicates predictable delivery.
      </p>
    </div>
  );
}

export function TeamVelocityComparison() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">👥 Team Velocity Comparison</h3>
      <MetricBarChart
        data={teamComparisonData}
        bars={[
          { dataKey: 'thisWeek', name: 'This Sprint', color: '#E89841' },
          { dataKey: 'lastWeek', name: 'Last Sprint', color: '#4A90E2' },
        ]}
        xAxisLabel="Team"
        yAxisLabel="Story Points"
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Frontend team increased velocity by 25%. Backend and DevOps teams show slight decrease -
        investigate potential blockers during sprint retrospective.
      </p>
    </div>
  );
}
